import { useTranslation } from 'next-i18next';
import React, { FC } from 'react';
import classNames from 'classnames';
import getClassNames from 'src/common/utils/getClassNames';
import Button from 'src/common/components/Button';
import Icon from 'src/common/components/Icon';
import styles from './FilterButton.module.scss';

type FilterButtonProps = {
  activeFiltersCount: number;
  onClick: () => void;
};

const FilterButton: FC<FilterButtonProps> = ({ activeFiltersCount, onClick }) => {
  const [t] = useTranslation('search-page');
  const filtersDirty = activeFiltersCount > 0;

  return (
    <Button
      classNameModifier="searchFilters"
      onClick={onClick}
      type="button"
      data-test="filter"
    >
      <Icon className={styles.icon} id="search/filter" />
      <span className={getClassNames(styles, 'label', classNames({ filtersDirty }))}>
        {t('filter-button')}
      </span>
      {filtersDirty && <span className={styles.count}>{` ${activeFiltersCount}`}</span>}
    </Button>
  );
};

export default FilterButton;
